var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty_page"},[_c('div',{staticClass:"empty"},[_c('img',{staticClass:"icon",attrs:{"src":_vm.icon}}),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }